<template>
    <div>
        <el-breadcrumb separator="/">
            <el-breadcrumb-item>
                <span class="page-title">代理商管理系统</span>
            </el-breadcrumb-item>
            <el-breadcrumb-item>代理商管理</el-breadcrumb-item>
        </el-breadcrumb>

        <div style="margin-top: 20px">

            <el-input placeholder="请输入用户ID" v-model="queryParams.userId" style="width: 300px"></el-input>
            <el-select v-model="queryParams.status" placeholder="选择状态">
                <el-option label="全部" value=""></el-option>
                <el-option label="显示" :value="0"></el-option>
                <el-option label="隐藏" :value="1"></el-option>
            </el-select>
            <el-button type="primary" @click="searchData">搜索</el-button>
            <el-button @click="dialogVisible=true" icon="el-icon-plus">添加</el-button>

            <el-table border :header-cell-style="{background:'#FFF5F4',color:'#EC6D56'}" style="margin-top: 20px"
                      :data="dataList" :row-key="() => Math.random()">
                <el-table-column prop="id" label="代理商ID" show-overflow-tooltip></el-table-column>
                <el-table-column prop="userId" label="用户ID" show-overflow-tooltip></el-table-column>
                <el-table-column prop="userName" label="用户名称" show-overflow-tooltip></el-table-column>
                <el-table-column prop="realName" label="是否实名" show-overflow-tooltip></el-table-column>
                <el-table-column prop="email" label="邮箱" show-overflow-tooltip></el-table-column>
                <el-table-column prop="tel" label="电话" show-overflow-tooltip></el-table-column>
                <el-table-column prop="userAmount" label="交易人数" show-overflow-tooltip></el-table-column>
                <el-table-column prop="userNums" label="用户数" show-overflow-tooltip></el-table-column>
                <el-table-column prop="bonus" label="佣金数" show-overflow-tooltip></el-table-column>
                <el-table-column prop="productType" label="代理产品" show-overflow-tooltip></el-table-column>
                <el-table-column prop="grade" label="代理商等级" show-overflow-tooltip></el-table-column>
                <el-table-column prop="inviteCode" label="邀请码" show-overflow-tooltip></el-table-column>
                <el-table-column prop="version" label="版本号" show-overflow-tooltip></el-table-column>
                <el-table-column prop="remark" label="备注" show-overflow-tooltip></el-table-column>
                <el-table-column label="更新时间" width="200px">
                    <template slot-scope="scope">
                        <span>{{scope.row.updateTime | moment}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="创建时间" width="200px">
                    <template slot-scope="scope">
                        <span>{{scope.row.createTime | moment}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="状态">
                    <template slot-scope="scope">
                        <el-switch :value="!scope.row.status" active-color="#13ce66" inactive-color="#ff4949"
                                   @change="updateAgent(scope.row,$event)"></el-switch>
                    </template>
                </el-table-column>
                <el-table-column label="操作" fixed="right" width="100px">
                    <template slot-scope="scope">
                        <el-button type="danger" @click="deleteAgent(scope.row.id)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination style="margin-top: 30px"
                           @size-change="handleSizeChange"
                           @current-change="handleCurrentChange"
                           :current-page="queryParams.page"
                           :page-sizes="[10, 20, 50, 100]"
                           :page-size="queryParams.size"
                           layout="total, sizes, prev, pager, next, jumper"
                           :total="total">
            </el-pagination>
        </div>

        <el-dialog title="添加代理商" :visible.sync="dialogVisible" width="600px" :close-on-click-modal="false"
                   @close="clearData">
            <el-form label-width="100px">
                <el-form-item label="用户ID：">
                    <el-input v-model="userId"></el-input>
                </el-form-item>
            </el-form>

            <span slot="footer" class="dialog-footer">
                <el-button type="danger" @click="addAgent">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import './store';
    import api from './api';

    export default {
        name: 'AgentManage',
        data() {
            return {
                dataList: [],
                total: 0,
                queryParams: {
                    userId: "",
                    status: "",
                    page: 1,
                    size: 10
                },
                userId: "",
                dialogVisible: false
            };
        },

        methods: {
            searchData() {
                this.queryParams.page = 1;
                this.getAgentList();
            },
            addAgent() {
                if (this.userId.trim() == "") {
                    this.$message.error('请输入用户ID！');
                    return;
                }
                api.addOrUpdateAgent({userId: this.userId}).then(({data}) => {
                    this.$message.success('增加成功！');
                    this.getAgentList();
                    this.dialogVisible = false;
                });
            },
            updateAgent(row, status) {
                let data = {...row};
                data.status = !status;
                api.addOrUpdateAgent(data).then(({data}) => {
                    this.$message.success('操作成功！');
                    this.getAgentList();
                });
            },
            getAgentList() {
                api.getAgentList(this.queryParams).then(({data}) => {
                    this.dataList = data.records;
                    this.total = data.total;
                });
            },
            deleteAgent(id) {
                this.$confirm('确认删除吗？', '提示', {
                    type: 'warning'
                }).then(() => {
                    api.deleteAgent({id: id}).then(({data}) => {
                        this.$message.success('删除成功！');
                        this.getAgentList();
                    });
                }).catch(() => {
                });
            },
            handleSizeChange(val) {
                this.queryParams.size = val;
                this.getAgentList();
            },
            handleCurrentChange(val) {
                this.queryParams.page = val;
                this.getAgentList();
            },
            clearData() {
                this.userId = "";
            }
        },
        created() {
            this.getAgentList();
        }
    };
</script>

<style lang="less" scoped>

</style>